export const CHANGELOG_RELEASES = [
  {
    "version": "1.80.3",
    "date": "2026-10-22",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**bluebox:** unidade do espectro FFT em mg (nao m/s2)"
        ]
      }
    ]
  },
  {
    "version": "1.80.2",
    "date": "2026-10-22",
    "groups": [
      {
        "title": "Estilo / UI",
        "items": [
          "**bluebox:** barras do espectro FFT como hastes finas"
        ]
      }
    ]
  },
  {
    "version": "1.80.1",
    "date": "2026-10-21",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "atualizar Bluebox a cada 3 segundos"
        ]
      }
    ]
  },
  {
    "version": "1.80.0",
    "date": "2026-10-21",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**bluebox:** espectro FFT em barras com deteccao de picos e simulador"
        ]
      }
    ]
  },
  {
    "version": "1.79.2",
    "date": "2026-10-20",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "ocultar energia total da Bluebox"
        ]
      }
    ]
  },
  {
    "version": "1.79.1",
    "date": "2026-10-20",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "atualizar telemetria da Bluebox a cada 5 segundos"
        ]
      }
    ]
  },
  {
    "version": "1.79.0",
    "date": "2026-10-20",
    "groups": [
      {
        "title": "Features",
        "items": [
          "adicionar eixos FFT da Bluebox"
        ]
      }
    ]
  },
  {
    "version": "1.78.0",
    "date": "2026-10-20",
    "groups": [
      {
        "title": "Features",
        "items": [
          "adicionar FFT e ajustes das Bluebox"
        ]
      }
    ]
  },
  {
    "version": "1.77.4",
    "date": "2026-10-17",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**ci:** prevent partial release pushes",
          "**ci:** restore release changelog state",
          "correct variable linking flow",
          "include pending variable list corrections"
        ]
      },
      {
        "title": "Refactor",
        "items": [
          "**variaveis:** exibir supervisorio em lista"
        ]
      }
    ]
  },
  {
    "version": "1.77.3",
    "date": "2026-10-16",
    "groups": [
      {
        "title": "Refactor",
        "items": [
          "**variaveis:** exibir supervisorio em lista"
        ]
      }
    ]
  },
  {
    "version": "1.77.2",
    "date": "2026-10-16",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "ajustar visualização das Bluebox"
        ]
      }
    ]
  },
  {
    "version": "1.77.1",
    "date": "2026-10-01",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "improve variable modal selectors"
        ]
      }
    ]
  },
  {
    "version": "1.77.0",
    "date": "2026-09-03",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**changelog:** add backend changelog page"
        ]
      }
    ]
  },
  {
    "version": "1.76.1",
    "date": "2026-09-03",
    "groups": [
      {
        "title": "Estilo / UI",
        "items": [
          "**usuarios:** input com box-sizing border-box (nao vaza da modal)"
        ]
      }
    ]
  },
  {
    "version": "1.76.0",
    "date": "2026-09-03",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**usuarios:** admin pode definir senha nova na edicao do usuario"
        ]
      }
    ]
  },
  {
    "version": "1.75.0",
    "date": "2026-08-21",
    "groups": [
      {
        "title": "Features",
        "items": [
          "adiciona logs de alteração na tela da máquina"
        ]
      }
    ]
  },
  {
    "version": "1.74.0",
    "date": "2026-08-19",
    "groups": [
      {
        "title": "Features",
        "items": [
          "add audit log filters and user name column"
        ]
      }
    ]
  },
  {
    "version": "1.73.0",
    "date": "2026-08-19",
    "groups": [
      {
        "title": "Features",
        "items": [
          "add audit logs screen"
        ]
      }
    ]
  },
  {
    "version": "1.72.0",
    "date": "2026-08-12",
    "groups": [
      {
        "title": "Features",
        "items": [
          "add changelog page"
        ]
      }
    ]
  },
  {
    "version": "1.71.1",
    "date": "2026-08-10",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**variaveis:** lista mostra variaveis cadastradas mesmo sem telemetria"
        ]
      }
    ]
  },
  {
    "version": "1.71.0",
    "date": "2026-08-10",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**simulador:** libera simulador tambem para Daniela Losekan"
        ]
      },
      {
        "title": "Estilo / UI",
        "items": [
          "**simulador:** botao com fundo solido (evita vazar conteudo atras)"
        ]
      }
    ]
  },
  {
    "version": "1.70.0",
    "date": "2026-08-10",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**aplicacao:** velocimetro e energia por periodo entram no simulador",
          "**app:** modo simulador (dados fake) exclusivo do desenvolvedor",
          "**grafico:** historico entra no modo simulador",
          "**simulador:** inclinacao cicla angulos (45/90/...) a cada ativacao"
        ]
      },
      {
        "title": "Estilo / UI",
        "items": [
          "**aplicacao:** altura do palco da bluebox proporcional ao grau",
          "**aplicacao:** espaco quadrado da imagem da bluebox pra rotacao",
          "**aplicacao:** remove setas de fluxo na bluebox"
        ]
      }
    ]
  },
  {
    "version": "1.69.0",
    "date": "2026-08-10",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**aplicacao:** bluebox troca eficiencia por fator de potencia e mostra horimetro"
        ]
      },
      {
        "title": "Estilo / UI",
        "items": [
          "**aplicacao:** resumo da bluebox em 2x2 (potencia/FP em cima, alarme/horimetro embaixo)"
        ]
      }
    ]
  },
  {
    "version": "1.68.0",
    "date": "2026-08-10",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**aplicacao:** barra de status operacional equivalente na bluebox",
          "**aplicacao:** bluebox usa suas 6 variaveis principais nos cards",
          "**aplicacao:** imagem da bluebox inclina conforme a variavel Tilt",
          "**aplicacao:** indicador de bateria estilo mobile na bluebox",
          "**aplicacao:** KPIs do Resumo da bluebox usam as variaveis MQTT dela",
          "**aplicacao:** linha de nivel de referencia na imagem da bluebox",
          "**aplicacao:** selo de inclinacao no meio da linha de nivel (bluebox)"
        ]
      },
      {
        "title": "Correções",
        "items": [
          "**aplicacao:** status da bluebox fica desativado sem dados",
          "**line-chart:** format timestamps locally",
          "**machines:** move bluebox to machine type"
        ]
      },
      {
        "title": "Estilo / UI",
        "items": [
          "**aplicacao:** selo de inclinacao mostra so os graus (bluebox)"
        ]
      }
    ]
  },
  {
    "version": "1.67.0",
    "date": "2026-08-06",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**aplicacao:** imagem do diagrama por tema (light/dark)",
          "**mapa:** mostra total gerado/consumido por maquina no ranking"
        ]
      }
    ]
  },
  {
    "version": "1.66.3",
    "date": "2026-08-06",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**grafico:** limite de range so aparece dentro do dominio Y"
        ]
      }
    ]
  },
  {
    "version": "1.66.2",
    "date": "2026-08-06",
    "groups": [
      {
        "title": "Refactor",
        "items": [
          "**aplicacao:** agrupa blocos analiticos em abas por tema",
          "**aplicacao:** disponibilidade vira aba propria",
          "**aplicacao:** move detalhes operacionais pra acima da disponibilidade",
          "**aplicacao:** remove sub-abas do detalhe e Log vira aba de topo"
        ]
      },
      {
        "title": "Estilo / UI",
        "items": [
          "**aplicacao:** move aba Por maquina pra logo apos Operacao"
        ]
      }
    ]
  },
  {
    "version": "1.66.1",
    "date": "2026-08-05",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "keep chart aligned with live updates"
        ]
      }
    ]
  },
  {
    "version": "1.66.0",
    "date": "2026-08-05",
    "groups": [
      {
        "title": "Features",
        "items": [
          "add bluebox machine flow"
        ]
      }
    ]
  },
  {
    "version": "1.65.0",
    "date": "2026-07-27",
    "groups": [
      {
        "title": "Features",
        "items": [
          "atualiza documentos dinamicos de IoT"
        ]
      }
    ]
  },
  {
    "version": "1.64.1",
    "date": "2026-07-21",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "include smartpump fields in iot subscription"
        ]
      }
    ]
  },
  {
    "version": "1.64.0",
    "date": "2026-07-20",
    "groups": [
      {
        "title": "Features",
        "items": [
          "exibir variavel nas notificacoes"
        ]
      }
    ]
  },
  {
    "version": "1.63.0",
    "date": "2026-07-17",
    "groups": [
      {
        "title": "Features",
        "items": [
          "improve cco notification alerts UI"
        ]
      }
    ]
  },
  {
    "version": "1.62.6",
    "date": "2026-07-08",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "corrige acionamento do cadastro de usuários"
        ]
      }
    ]
  },
  {
    "version": "1.62.5",
    "date": "2026-07-08",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "corrige payload e feedback nos cadastros de estações e usuários"
        ]
      }
    ]
  },
  {
    "version": "1.62.4",
    "date": "2026-07-08",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**mapa:** mostra geracao mesmo em parque com alarme e corrige sinal",
          "**mapa:** separa geracao (TGA) de potencia (bomba) no balao do mapa"
        ]
      },
      {
        "title": "Estilo / UI",
        "items": [
          "**mapa:** balao usa so icone (raio=TGA, gota=bomba), sem rotulo texto"
        ]
      }
    ]
  },
  {
    "version": "1.62.3",
    "date": "2026-06-23",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**plant:** empty-state de energia/vazao deixa claro que e da maquina"
        ]
      }
    ]
  },
  {
    "version": "1.62.1",
    "date": "2026-06-23",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**ui:** Ctrl+K abria dois palettes (QuickSearch + CommandPalette)"
        ]
      }
    ]
  },
  {
    "version": "1.62.0",
    "date": "2026-06-23",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**notifications:** skeleton rows no carregamento"
        ]
      }
    ]
  },
  {
    "version": "1.61.0",
    "date": "2026-06-23",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**ui:** grupo 'Acoes' no Ctrl+K (navegar pra telas)"
        ]
      }
    ]
  },
  {
    "version": "1.60.0",
    "date": "2026-06-23",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**ui:** 'Recentes' no Ctrl+K (maquinas vistas recentemente)"
        ]
      }
    ]
  },
  {
    "version": "1.59.0",
    "date": "2026-06-23",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**all-variables:** escala min/max sob o gauge do supervisorio, closes [#5](https://github.com/jonathanhigra/higra-cco-front/issues/5)"
        ]
      }
    ]
  },
  {
    "version": "1.58.0",
    "date": "2026-06-23",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**all-variables:** navegacao fixa de categorias no supervisorio, closes [#3](https://github.com/jonathanhigra/higra-cco-front/issues/3)"
        ]
      }
    ]
  },
  {
    "version": "1.57.0",
    "date": "2026-06-23",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**all-variables:** gauge so em medicao fisica; numero pro resto, closes [#1](https://github.com/jonathanhigra/higra-cco-front/issues/1)"
        ]
      }
    ]
  },
  {
    "version": "1.56.0",
    "date": "2026-06-23",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**all-variables:** botao Configurar aparece no hover do card, closes [#4](https://github.com/jonathanhigra/higra-cco-front/issues/4)",
          "**all-variables:** destaca card de variavel em atencao/alarme, closes [#2](https://github.com/jonathanhigra/higra-cco-front/issues/2)"
        ]
      }
    ]
  },
  {
    "version": "1.55.0",
    "date": "2026-06-22",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**notifications:** clicar na notificacao abre o alarme na maquina"
        ]
      }
    ]
  },
  {
    "version": "1.54.0",
    "date": "2026-06-22",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**plant:** um unico slot 'Adicionar' nos favoritos (sem parede de placeholders)"
        ]
      }
    ]
  },
  {
    "version": "1.53.0",
    "date": "2026-06-22",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**plant:** estado saudavel na disponibilidade sem paradas"
        ]
      },
      {
        "title": "Correções",
        "items": [
          "**plant:** grafico diario com tudo zerado mostra mensagem, nao eixo plano"
        ]
      }
    ]
  },
  {
    "version": "1.52.0",
    "date": "2026-06-22",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** melhora disposicao do painel de detalhe do marker"
        ]
      }
    ]
  },
  {
    "version": "1.51.0",
    "date": "2026-06-22",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** selo de frescor do dado no painel da maquina"
        ]
      }
    ]
  },
  {
    "version": "1.50.0",
    "date": "2026-06-22",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** contagem por status na legenda do mapa",
          "**plant:** tooltips explicativos nos KPIs sem explicacao"
        ]
      }
    ]
  },
  {
    "version": "1.49.0",
    "date": "2026-06-22",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**plant:** DeltaPill no financeiro (receita/custo e energia)",
          "**plant:** DeltaPill nos KPIs de disponibilidade"
        ]
      }
    ]
  },
  {
    "version": "1.48.0",
    "date": "2026-06-18",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**plant:** detalhes operacionais da maquina abaixo do grafico"
        ]
      }
    ]
  },
  {
    "version": "1.47.0",
    "date": "2026-06-18",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** marker do parque vira pizza por status das maquinas"
        ]
      }
    ]
  },
  {
    "version": "1.46.0",
    "date": "2026-06-16",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** toggle TGA/Bombas e vazao no ranking de bombas"
        ]
      }
    ]
  },
  {
    "version": "1.45.2",
    "date": "2026-06-14",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**ui:** listas e selects de filtro em ordem alfabetica"
        ]
      }
    ]
  },
  {
    "version": "1.45.1",
    "date": "2026-06-12",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**dashboard:** estados em ordem alfabetica na lista de zonas"
        ]
      }
    ]
  },
  {
    "version": "1.45.0",
    "date": "2026-06-12",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** pan e zoom continuos (segurar) no pad do telao",
          "**dashboard:** toggle Geracao/Consumo no dock do telao"
        ]
      }
    ]
  },
  {
    "version": "1.44.0",
    "date": "2026-06-12",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**ui:** busca global Ctrl+K (maquinas, parques e clientes)"
        ]
      }
    ]
  },
  {
    "version": "1.43.0",
    "date": "2026-06-12",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**ui:** EmptyState padrao com acao nas telas de listagem"
        ]
      }
    ]
  },
  {
    "version": "1.42.14",
    "date": "2026-06-12",
    "groups": [
      {
        "title": "Estilo / UI",
        "items": [
          "**dashboard:** harmoniza anatomia de alertas e atividades no painel"
        ]
      }
    ]
  },
  {
    "version": "1.42.13",
    "date": "2026-06-12",
    "groups": [
      {
        "title": "Estilo / UI",
        "items": [
          "**signup:** redesign no shell do login (CCO)"
        ]
      }
    ]
  },
  {
    "version": "1.42.9",
    "date": "2026-06-12",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**a11y:** aria-label nos inputs de senha do signup e token no forgot, closes [#71767](https://github.com/jonathanhigra/higra-cco-front/issues/71767) [#1cb0d8](https://github.com/jonathanhigra/higra-cco-front/issues/1cb0d8)"
        ]
      }
    ]
  },
  {
    "version": "1.42.8",
    "date": "2026-06-12",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**a11y:** aria-label nos botoes-icone das tabelas"
        ]
      }
    ]
  },
  {
    "version": "1.42.7",
    "date": "2026-06-12",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**events:** toast no lugar do textarea pos-rearme"
        ]
      },
      {
        "title": "Estilo / UI",
        "items": [
          "**events:** migra painel de eventos pros tokens CCO, closes [#801919](https://github.com/jonathanhigra/higra-cco-front/issues/801919) [#EB6D70](https://github.com/jonathanhigra/higra-cco-front/issues/EB6D70)"
        ]
      }
    ]
  },
  {
    "version": "1.42.6",
    "date": "2026-06-12",
    "groups": [
      {
        "title": "Estilo / UI",
        "items": [
          "**button:** estados disabled e focus nos tokens CCO",
          "**input:** tokens CCO na hairline/foco e altura responsiva",
          "**loader:** cor do tema no lugar do azul hardcoded, closes [#0A1F8](https://github.com/jonathanhigra/higra-cco-front/issues/0A1F8)"
        ]
      }
    ]
  },
  {
    "version": "1.42.3",
    "date": "2026-06-10",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**dashboard:** cluster soma MAQUINAS, nao parques"
        ]
      }
    ]
  },
  {
    "version": "1.42.2",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**plant:** hairline entre secoes voltava a renderizar"
        ]
      }
    ]
  },
  {
    "version": "1.42.1",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Estilo / UI",
        "items": [
          "**plant:** labels intuitivos pra MTBF/MTTR"
        ]
      }
    ]
  },
  {
    "version": "1.42.0",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**plant:** secao de desvios do padrao (anomalias v1)"
        ]
      }
    ]
  },
  {
    "version": "1.41.0",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** triagem de alarme com IA no painel de alertas"
        ]
      }
    ]
  },
  {
    "version": "1.40.0",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** copiloto de perguntas no modal do resumo do turno"
        ]
      }
    ]
  },
  {
    "version": "1.39.0",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** botao do resumo do turno so aparece com LLM habilitado",
          "**dashboard:** resumo do turno gerado por IA"
        ]
      },
      {
        "title": "Correções",
        "items": [
          "**dashboard:** aceita sinceTs em ISO no resumo do turno"
        ]
      }
    ]
  },
  {
    "version": "1.38.0",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**operational:** confirmacao dupla antes de enviar comando"
        ]
      },
      {
        "title": "Correções",
        "items": [
          "**dashboard:** escapa valores interpolados no SVG do cluster",
          "**deps:** atualiza axios 0.21 para 1.x"
        ]
      }
    ]
  },
  {
    "version": "1.37.0",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** exibe modelo do equipamento no card Top Geracao"
        ]
      }
    ]
  },
  {
    "version": "1.36.3",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**dashboard:** alert dock translucido pro liquid glass aparecer no telao"
        ]
      }
    ]
  },
  {
    "version": "1.36.2",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Estilo / UI",
        "items": [
          "**dashboard:** liquid glass nos docks do telao (Top Geracao + Alertas)"
        ]
      }
    ]
  },
  {
    "version": "1.36.1",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Estilo / UI",
        "items": [
          "**dashboard:** cards de totais com fundo liquid glass no telao"
        ]
      }
    ]
  },
  {
    "version": "1.36.0",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** pad de navegacao manual (pan + zoom) no telao"
        ]
      }
    ]
  },
  {
    "version": "1.35.5",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**dashboard:** tira botao tela cheia e pill de status de baixo do dock"
        ]
      }
    ]
  },
  {
    "version": "1.35.3",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**dashboard:** cards de totais responsivos sem sobrepor os docks"
        ]
      }
    ]
  },
  {
    "version": "1.35.2",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**dashboard:** parsing do Top Geracao (resposta com data aninhado)"
        ]
      }
    ]
  },
  {
    "version": "1.35.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** dock Top Geracao no telao (substitui a legenda)"
        ]
      }
    ]
  },
  {
    "version": "1.34.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**customers:** edicao inline da tarifa padrao por cliente"
        ]
      }
    ]
  },
  {
    "version": "1.33.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**plant:** cadastro de tarifa e potencia nominal (restrito)",
          "**plant:** KPI de fator de capacidade (UCHA)",
          "**plant:** KPI financeiro (custo/receita) por tarifa"
        ]
      }
    ]
  },
  {
    "version": "1.32.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**plant:** analitica de alarmes (downtime + Pareto) no Log",
          "**plant:** dispersao (ponto de operacao) no modal avancado",
          "**plant:** KPIs de disponibilidade real + MTBF/MTTR"
        ]
      }
    ]
  },
  {
    "version": "1.31.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**plant:** comparacao de potencia por maquina",
          "**plant:** curva de duracao de carga no modal avancado"
        ]
      }
    ]
  },
  {
    "version": "1.30.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** spiderfy no cluster e indicador de comando pendente (lote 3)"
        ]
      }
    ]
  },
  {
    "version": "1.29.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** realce no hover e link lista-mapa (lote 2)"
        ]
      }
    ]
  },
  {
    "version": "1.28.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** melhorias nos markers e baloes (lote 1)"
        ]
      }
    ]
  },
  {
    "version": "1.27.0",
    "date": "2026-06-04",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** exibe nome da maquina no alerta"
        ]
      }
    ]
  },
  {
    "version": "1.26.2",
    "date": "2026-06-03",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**dashboard:** centraliza totais na faixa entre legenda e dock de alertas"
        ]
      },
      {
        "title": "Estilo / UI",
        "items": [
          "**dashboard:** balao da UCHA laranja e geracao em modulo positivo, closes [#F6A560](https://github.com/jonathanhigra/higra-cco-front/issues/F6A560)",
          "**dashboard:** balao de potencia da EBA com gota e cor azul, closes [#4EA1F3](https://github.com/jonathanhigra/higra-cco-front/issues/4EA1F3)"
        ]
      }
    ]
  },
  {
    "version": "1.26.1",
    "date": "2026-06-03",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**dashboard:** cards de totais lado a lado na tela cheia"
        ]
      }
    ]
  },
  {
    "version": "1.26.0",
    "date": "2026-06-03",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** balao tempo-real em parque isolado em qualquer zoom"
        ]
      }
    ]
  },
  {
    "version": "1.25.0",
    "date": "2026-06-03",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** totais AGORA em tela cheia e correcao do pill de soma do cluster"
        ]
      }
    ]
  },
  {
    "version": "1.24.0",
    "date": "2026-06-03",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** soma tempo-real de geracao/consumo no balao do cluster"
        ]
      }
    ]
  },
  {
    "version": "1.23.0",
    "date": "2026-06-03",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** balao do marker mostra geracao (UCHA)/consumo (EBA), so rodando",
          "**variables:** modal no design CCO + pre-carrega maquinas vinculadas"
        ]
      }
    ]
  },
  {
    "version": "1.22.0",
    "date": "2026-06-03",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** link do painel de alertas para /notifications"
        ]
      }
    ]
  },
  {
    "version": "1.21.2",
    "date": "2026-06-03",
    "groups": [
      {
        "title": "Estilo / UI",
        "items": [
          "**dashboard:** modal de drill-down segue o design system (tokens CCO)"
        ]
      }
    ]
  },
  {
    "version": "1.21.1",
    "date": "2026-06-03",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**variables:** restringe gestao de variaveis a role higra (front)"
        ]
      }
    ]
  },
  {
    "version": "1.21.0",
    "date": "2026-06-03",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**operational:** abas Variaveis|Comandos + grid unificado de controles",
          "**operational:** banner de comando pendente no dispositivo (shadow)"
        ]
      }
    ]
  },
  {
    "version": "1.20.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**operational:** feedback de envio de comando + relabel 'despachado'"
        ]
      }
    ]
  },
  {
    "version": "1.19.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** 'ultima leitura ha X' em maquinas sem dados"
        ]
      }
    ]
  },
  {
    "version": "1.18.1",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Performance",
        "items": [
          "**dashboard:** throttle ~10s dos badges/tooltip do mapa"
        ]
      }
    ]
  },
  {
    "version": "1.18.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** historico de atividade server-side (duravel/cross-operador)"
        ]
      }
    ]
  },
  {
    "version": "1.17.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**ws:** envia token Cognito no handshake do socket (Fase 1 warn-only)"
        ]
      }
    ]
  },
  {
    "version": "1.16.1",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Estilo / UI",
        "items": [
          "**dashboard:** painel de alertas uniforme, sem rotulos de secao"
        ]
      }
    ]
  },
  {
    "version": "1.16.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** cue sonoro discreto para perda de comunicacao",
          "**dashboard:** historico persistente das notificacoes de atividade"
        ]
      }
    ]
  },
  {
    "version": "1.15.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** estado vazio no painel de alertas + fix do card cortado",
          "**dashboard:** feed de atividade + scroll discreto + dock em tela cheia"
        ]
      }
    ]
  },
  {
    "version": "1.14.1",
    "date": "2026-06-01",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**dashboard:** pill de duracao do alerta nao estica mais pela largura toda"
        ]
      }
    ]
  },
  {
    "version": "1.14.0",
    "date": "2026-06-01",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**appliance:** correlaciona evento do Log com marcador no grafico"
        ]
      }
    ]
  },
  {
    "version": "1.13.0",
    "date": "2026-06-01",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**appliance:** adiciona abas Detalhes/Log no detalhe operacional",
          "**appliance:** enriquece aba Log com filtros, reincidencia, limite e rearme"
        ]
      }
    ]
  },
  {
    "version": "1.12.0",
    "date": "2026-06-01",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** badges de cliente coloridos por tipo (laranja UCHA / azul EBA)"
        ]
      }
    ]
  },
  {
    "version": "1.11.1",
    "date": "2026-06-01",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**customer:** AGORA escopa por selecao (mapa/lista completos) + barra de escopo"
        ]
      }
    ]
  },
  {
    "version": "1.11.0",
    "date": "2026-06-01",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**stations,users,customers:** coluna \"Editar\" como primeira"
        ]
      }
    ]
  },
  {
    "version": "1.10.0",
    "date": "2026-06-01",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**machines:** coluna \"Atualizacao\" (ultima atualizacao de dados) + Editar primeiro"
        ]
      }
    ]
  },
  {
    "version": "1.9.0",
    "date": "2026-06-01",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** severidade visivel no \"Em alerta agora\""
        ]
      }
    ]
  },
  {
    "version": "1.8.0",
    "date": "2026-06-01",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**customer:** ordena cards de aplicacao por status"
        ]
      }
    ]
  },
  {
    "version": "1.7.1",
    "date": "2026-06-01",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**customer:** card de aplicacao usa status agregado (remove override Sta_Rodando)",
          "**dashboard:** mapa preso no F5 + evita fetch desperdicado de parques"
        ]
      }
    ]
  },
  {
    "version": "1.7.0",
    "date": "2026-05-31",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**charts:** suaviza modo avancado (toggle) + eixo Y por modo"
        ]
      }
    ]
  },
  {
    "version": "1.6.2",
    "date": "2026-05-30",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**charts:** historico por maquina+variavel + loader centralizado"
        ]
      }
    ]
  },
  {
    "version": "1.6.1",
    "date": "2026-05-30",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**dashboard:** badge de pot/vazao so em parque rodando ou em alarme"
        ]
      }
    ]
  },
  {
    "version": "1.6.0",
    "date": "2026-05-30",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** lista maquinas individuais com status no painel de detalhe"
        ]
      }
    ]
  },
  {
    "version": "1.5.0",
    "date": "2026-05-29",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**operational:** imagem responsiva, pins realinhados/arrastaveis e ajustes de layout"
        ]
      },
      {
        "title": "Refactor",
        "items": [
          "**operational:** consolida trava de comandos e migra Commands pra tokens CCO"
        ]
      }
    ]
  },
  {
    "version": "1.4.0",
    "date": "2026-05-29",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**carousel:** oculta setas quando ha so 1 maquina",
          "**line-chart:** eixo X de hora em hora no modo basico",
          "**plant:** contagem de maquinas no chip do Resumo e grid de KPIs uniforme"
        ]
      },
      {
        "title": "Estilo / UI",
        "items": [
          "**all-variables:** migra cards e header pra tokens --cco-*",
          "**operational-status:** reduz fonte dos badges pra nao truncar"
        ]
      }
    ]
  },
  {
    "version": "1.3.3",
    "date": "2026-05-28",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**dashboard:** alinha backdrop do html ao token --cco-bg, closes [#181818](https://github.com/jonathanhigra/higra-cco-front/issues/181818) [#F3F1F1](https://github.com/jonathanhigra/higra-cco-front/issues/F3F1F1)"
        ]
      }
    ]
  },
  {
    "version": "1.3.2",
    "date": "2026-05-28",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**dashboard:** ocultar estado/cliente sem equipamento na lista CCO",
          "**dashboard:** ocultar marker de parque sem equipamento ativo"
        ]
      }
    ]
  },
  {
    "version": "1.3.1",
    "date": "2026-05-28",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**side-menu:** menu acima dos controles do mapa (z-index)"
        ]
      }
    ]
  },
  {
    "version": "1.3.0",
    "date": "2026-05-28",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**machines:** toggle ativar/desativar maquina (soft hide)"
        ]
      }
    ]
  },
  {
    "version": "1.2.5",
    "date": "2026-05-28",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**forms:** modais de cadastro respeitam light/dark, closes [#0e0f12](https://github.com/jonathanhigra/higra-cco-front/issues/0e0f12)"
        ]
      }
    ]
  },
  {
    "version": "1.2.3",
    "date": "2026-05-28",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**chart:** labels do EnergyHistoryChart escuras no light"
        ]
      }
    ]
  },
  {
    "version": "1.2.2",
    "date": "2026-05-28",
    "groups": [
      {
        "title": "Estilo / UI",
        "items": [
          "**theme:** padroniza azuis em 2 valores canonicos ([#2](https://github.com/jonathanhigra/higra-cco-front/issues/2)F3877 + [#459](https://github.com/jonathanhigra/higra-cco-front/issues/459)FDC), closes [#2F3877](https://github.com/jonathanhigra/higra-cco-front/issues/2F3877) [#2F3877](https://github.com/jonathanhigra/higra-cco-front/issues/2F3877) [#2F3877](https://github.com/jonathanhigra/higra-cco-front/issues/2F3877) [#2f3877](https://github.com/jonathanhigra/higra-cco-front/issues/2f3877) [#1cb0d8](https://github.com/jonathanhigra/higra-cco-front/issues/1cb0d8) [#3ec0e0](https://github.com/jonathanhigra/higra-cco-front/issues/3ec0e0) [#6bc7e3](https://github.com/jonathanhigra/higra-cco-front/issues/6bc7e3) [#3a8](https://github.com/jonathanhigra/higra-cco-front/issues/3a8) [#192b80](https://github.com/jonathanhigra/higra-cco-front/issues/192b80) [#1e2944](https://github.com/jonathanhigra/higra-cco-front/issues/1e2944) [#2f3877](https://github.com/jonathanhigra/higra-cco-front/issues/2f3877)"
        ]
      }
    ]
  },
  {
    "version": "1.2.0",
    "date": "2026-05-28",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**variables:** pencil e cadastro abrem modal sobre a lista"
        ]
      },
      {
        "title": "Correções",
        "items": [
          "**variables:** modal de edicao carrega valores da row clicada",
          "**variables:** remove import useHistory orfao (quebrava build no CI)"
        ]
      },
      {
        "title": "Estilo / UI",
        "items": [
          "**side-menu:** Liquid Glass v2 — mais proximo do iOS Control Center",
          "**side-menu:** teste de Liquid Glass background (frosted)",
          "**variables:** modal bate com design antigo (pills + chips dark + SALVAR centralizado)"
        ]
      }
    ]
  },
  {
    "version": "1.1.1",
    "date": "2026-05-28",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**plant:** HeaderName em fluxo normal — resolve sobreposicao com breadcrumb"
        ]
      },
      {
        "title": "Estilo / UI",
        "items": [
          "**plant:** divider mais visivel entre breadcrumb e titulo"
        ]
      }
    ]
  },
  {
    "version": "1.1.0",
    "date": "2026-05-28",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**dashboard:** tabs mobile (Alertas/Mapa/Visao Geral) em <=720px",
          "**login:** lado do formulario theme-aware (light por padrao), closes [#1cb0d8](https://github.com/jonathanhigra/higra-cco-front/issues/1cb0d8) [#f4445](https://github.com/jonathanhigra/higra-cco-front/issues/f4445) [#f1c349](https://github.com/jonathanhigra/higra-cco-front/issues/f1c349)",
          "**nav:** bottom navigation mobile (<=720px)",
          "**theme:** tokens de tipografia fluida (clamp) no GlobalStyle",
          "**version:** banner dispara em qualquer deploy novo (detecta por commitSha)"
        ]
      },
      {
        "title": "Correções",
        "items": [
          "**dashboard:** aba Mapa mobile fica so com o mapa (sem alertas em cima)",
          "**dashboard:** mapa fita markers ao voltar pra aba Mapa no mobile",
          "**plant:** borda inferior dos ValueWrapper nao fica mais cortada",
          "**plant:** breadcrumb e titulo deixam de se sobrepor em widths estreitas",
          "**plant:** linha de status quebra no mobile em vez de espremer",
          "**plant:** StatusCard quebra em qualquer largura, nao so no mobile",
          "**responsive:** admin, support e maintenance no mobile (onda 1)",
          "**responsive:** appliance no mobile (onda 1)",
          "**responsive:** painel de eventos no mobile (onda 1)",
          "**responsive:** telas de senha/cadastro no mobile (onda 1)",
          "**responsive:** touch targets >=44px + AlertOverlay mobile (onda 3)",
          "**responsive:** variables/all-variables/reports/notifications/dashboard (onda 2)",
          "**version:** banner mostra numero da versao + fica theme-aware"
        ]
      },
      {
        "title": "Estilo / UI",
        "items": [
          "**customer:** melhora card de aplicacao no light/dark",
          "**plant:** centraliza StatusCard pra equilibrar quando quebra em 2 linhas",
          "**plant:** compacta status pills pra caber numa linha so",
          "**plant:** divider entre breadcrumb e titulo do header",
          "**plant:** pills de status crescem pra preencher a coluna disponivel",
          "**side-menu:** botao de expansao theme-aware (light/dark), closes [#1a2330](https://github.com/jonathanhigra/higra-cco-front/issues/1a2330) [#0a0d14](https://github.com/jonathanhigra/higra-cco-front/issues/0a0d14)"
        ]
      }
    ]
  }
];
